import './plugins'

export default {}